<template>
  <div class='resubRedirect--main'>
    <b-spinner
      v-if='isLoading'
      label="Large Spinner">
    </b-spinner>
  </div>
</template>

<script>
import { baseURL, path } from '@/axios'
import storage from '@/storage'
export default {
  name: 'resubmission-redirect-step-one',
  data () {
    return {
      isRedirected: false,
      isLoading: true
    }
  },
  created () {
    storage.set.lang(this.$route.params.lng)
    this.isRedirected = 'token' in this.$route.query
    localStorage.setItem('schools', 'resubmission')
    storage.set.resubmissionToken(this.$route.query.token)
    window.location.href = baseURL + path.citizensApp + '?resubmissionToken=' + this.$route.query.token
  }
}
</script>

<style lang='scss' scoped>
.resubRedirect--main {
  position: relative;
}
.spinner-border {
  position: absolute;
  top: 70%;
  left: 45%;
  width: 5rem;
  height: 5rem;
  border: 0.4em solid white;
  border-right-color: transparent;
}
.mt-app--box {
  min-height: 30vh;
  background-color: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
